import { List, ListItem, ListItemText, styled, Typography } from '@mui/material';
import React from 'react';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import { Menu } from '@mui/icons-material';

const SortableItem = sortableElement(({ value, enableSub = false, id, type = '' }) => (
  <ListItem
    button
    style={{
      padding: '8px 16px',
      transition: 'background-color 0.3s',
      border: '1px solid lightgrey',
      borderRadius: '4px',
      marginBottom: '4px',
      '&:hover': { backgroundColor: '#f0f0f0' },
      cursor: 'grab',
    }}
  >
    <Menu style={{ color: 'lightgrey', marginRight: '8px' }} />
    <ListItemText
      primary={<TitleTypography>{value}</TitleTypography>}
      secondary={
        enableSub ? (
          <SubtitleTypography variant="body2" color="textSecondary">
            {`${type} ${id}`}
          </SubtitleTypography>
        ) : null
      }
    />
  </ListItem>
));

const SortableContainer = sortableContainer(({ children }) => <List>{children}</List>);

const ReorderComponent = ({ items, onSortEnd, enableSub = false, type = '' }) => (
  <SortableContainer onSortEnd={onSortEnd}>
    {items.map((item, index) => (
      <SortableItem
        key={`${String(item.id)}`}
        index={index}
        value={item.title || item.name}
        id={item.seqId}
        enableSub={enableSub}
        type={type}
      />
    ))}
  </SortableContainer>
);

const TitleTypography = styled(Typography)`
  font-family: Lato;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.32px;
`;

const SubtitleTypography = styled(Typography)`
  font-family: Lato;
  font-size: 10px;
  font-weight: 500;
  line-height: 13.8px;
`;

export default ReorderComponent;
